import styled from 'styled-components';
import { defaultTransition, marginReplacer, hexa } from 'styles/utils';
import { Link } from 'core/routing';

const MAIN_HEIGHT = 48;

export const OutsideWrapper = styled.div`
  position: relative;
  width: fit-content;
`;

export const SelectMainWrapper = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  height: ${MAIN_HEIGHT}px;
  margin: ${props => (props.margin ? marginReplacer(props.margin) : '0')};
  margin-bottom: 0;
  padding: 8px 8px 8px 16px;
  border: ${props =>
    props.type === 'rectangle'
      ? `1px solid ${props.theme.color.wfBlack}`
      : 'none'};
  background-color: ${props => props.theme.color.wfWhite};
  cursor: pointer;
`;

export const MainTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentWrapper = styled.ul`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${props => (props.margin ? marginReplacer(props.margin) : '0')};
  transform-origin: top;
  transform: translateY(-1px) scaleY(${props => (props.isOpen ? '1' : '0')});
  opacity: ${props => (props.isOpen ? '1' : '0')};
  overflow: hidden;
  background-color: ${props => props.theme.color.wfWhite};
  z-index: 100;

  ${props =>
    props.positionFixed &&
    `
    position: fixed;
    top: ${props.top + MAIN_HEIGHT - props.parentScroll}px;
  `}

  ${props =>
    props.type === 'rectangle' &&
    `
    width: 12rem;
    max-width: 24rem;
    margin-top: 16px;
    border: 1px solid ${props.theme.color.wfBlack};
    ${defaultTransition('all')}
  `}

  ${props =>
    props.type === 'table' &&
    `
    left: 50%;
    transform: translateX(-50%);
    box-shadow: ${hexa(props.theme.color.wfGrey700, 0.2)} 0px 7px 29px 0px;
    margin-top: -${MAIN_HEIGHT}px;
    ${defaultTransition('opacity')}
  `}

  ${props =>
    props.type === 'minimal' &&
    `
    border: 1px solid ${props.theme.color.wfGrey300};
    ${defaultTransition(props.positionFixed ? 'all' : 'opacity')}
  `}

  ${props =>
    props.type === 'burger' &&
    `
    margin: -24px 0 0 8px;
    min-width: 15rem;
    border: 1px solid ${props.theme.color.wfGrey800};
    box-shadow: 0px 4px 20px ${hexa(props.theme.color.wfBlack, 0.25)};
  `}
`;

export const StyledLink = styled(Link)`
  width: 100%;
`;

export const RowWrapper = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;

  ${props =>
    props.type === 'rectangle' &&
    `
    margin: 0.25rem 0;
    padding: 0.5rem 1rem;
    background-color: ${
      props.selected ? props.theme.color.wfGrey400 : props.theme.color.wfWhite
    };

    &:hover {
      background-color: ${
        props.selected
          ? props.theme.color.wfGrey500
          : props.theme.color.wfGrey100
      };
    }
  `}

  ${props =>
    props.type === 'table' &&
    `
    padding: 0.5rem 1rem;

    div > h5 {
      color: ${
        props.selected ? props.theme.color.primary : props.theme.color.wfBlack
      };
    }

    &:hover {
      div > h5 {
        color: ${
          props.selected
            ? props.theme.color.wfBlue800
            : props.theme.color.wfGrey800
        };
      }
    }
  `}

  ${props =>
    props.type === 'minimal' &&
    `
    margin: 0.25rem 0;
    padding: 0.5rem 1rem;

    div > h5 {
      color: ${
        props.selected ? props.theme.color.primary : props.theme.color.wfBlack
      };
    }

    &:hover {
      background-color: ${props.theme.color.wfGrey100};
    }
  `}

  ${props =>
    props.type === 'burger' &&
    `
    padding: 0.75rem 1rem;
    background-color: ${props.theme.color.wfBlack};

    svg {
      path {
        fill: ${props.theme.color.wfWhite};
      }
    }

    div > h5 {
      color: ${props.theme.color.wfWhite};
    }

    &:hover {
      background-color: ${props.theme.color.wfGrey900};
    }
  `}
`;

export const RowColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const WhiteBar = styled.div`
  display: ${props => props.type !== 'rectangle' && 'none'};
  position: absolute;
  width: calc(100% + 2px);
  height: 18px;
  background-color: ${props => props.theme.color.wfWhite};
  transform: translate(-17px, calc(100% + 13px));
  opacity: ${props => (props.isOpen ? '1' : '0')};
  border-right: 1px solid ${props => props.theme.color.wfBlack};
  border-left: 1px solid ${props => props.theme.color.wfBlack};
  z-index: 101;

  div {
    margin: 0 1rem;
    border-top: 1px solid ${props => props.theme.color.wfBlack};
  }
`;

export const TableWhiteBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  div {
    width: 80%;
    height: 1rem;
    border-top: 1px solid ${props => props.theme.color.wfBlack};
  }
`;
